import ColorThief from 'colorthief';
import 'amfe-flexible'
import "./style/index.css";
import $ from "jquery";

$(function () {
  // 短剧周榜
  $.ajax({
    url: '//apppc.cnr.cn/shortplays/rank',
    type: 'post',
    dataType: 'json',
    data: JSON.stringify({
      rankType: 1,
      pageIndex: 1,
      perPage: 5,
    }),
    success: function (data) {
      if (data.code == 200) {
        const result = data.data.rankList;
        $('.ranking__weekly .ranking__list').html(
          result.map((item, index) => {
            const trendIcon = {
              1: 'down',
              2: 'up',
            }[item.trend] || '';
            const svgNumber = ['1', '2', '3', '4', '5'][index];
            const svgIcon = ['https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/34f36aa1f8f5e175272381484576508610.png?auth=3a11fe8e97826f2e8725b1048782d860', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/5b81892561a22175272382087188261710.png?auth=f074f1b0cda8ebbb8d55f58a997343dc', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/2536d280e3445175272382660659552510.png?auth=b41e12e6980c56aa81ca5ddd8117c5ae', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/7064a6085a751752723876909641854010.png?auth=902f1d2414fd57e054bfd6d73814c346', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/7064a6085a751752723876909641854010.png?auth=902f1d2414fd57e054bfd6d73814c346'][index];

            return `
              <div class="flex__row ranking__list__item">
                  <div class="ranking__list__item__content__num">
                    <div class="svgIcon"><img src="${svgIcon}"></div>
                    <div class="ranking__list__item__content__num_text">${index + 1}</div>
                  </div>
                  <div class="ranking__list__item__content">
                    <div class="news--body--item--text">
                      <div class="news--body--item--text--title">
                        ${item.shortPlayTitle}
                      </div>
                    </div>
                    <div class="ranking__list__item__content__trend">
                      <span class="${trendIcon}"></span>
                    </div>
                    <div class="ranking__list__item__content__other">
                      <span class="ranking__list__item__content__other__play">
                        <span class="tag">播放量</span>
                        <span class="number">${(item.viewCount + '').slice(0, -4) + 'W'}</span>
                      </span>
                    </div>
                  </div>
                  <div class="news--body--item--pic">
                    <div class="playlet--poster">
                      <div class="playlet--poster__vertical">
                        
                          <img crossorigin="anonymous" class="playlet--poster--image" src="${item.img1}" alt="">
                       
                      </div>
                    </div>
                  </div>
                </div>
            `;
          }).join(''),
        );
      } else {
        console.log(data.message);
      }
    },
    fail: function (err) {
      console.log(err);
    },
  });

  // 口碑好剧
  $.ajax({
    url: '//apppc.cnr.cn/shortplays/rank',
    type: 'post',
    dataType: 'json',
    data: JSON.stringify({
      rankType: 2,
      pageIndex: 1,
      perPage: 5,
    }),
    success: function (data) {
      if (data.code === 200) {
        const result = data.data.rankList;
        $('.ranking__koubei .ranking__list').html(
          result.map((item, index) => {
            const trendIcon = {
              1: 'down',
              2: 'up',
            }[item.trend] || '';
            const svgNumber = ['1', '2', '3', '4', '5'][index];
            const svgIcon = ['https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/34f36aa1f8f5e175272381484576508610.png?auth=3a11fe8e97826f2e8725b1048782d860', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/5b81892561a22175272382087188261710.png?auth=f074f1b0cda8ebbb8d55f58a997343dc', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/2536d280e3445175272382660659552510.png?auth=b41e12e6980c56aa81ca5ddd8117c5ae', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/7064a6085a751752723876909641854010.png?auth=902f1d2414fd57e054bfd6d73814c346', 'https://mediabluk.cnr.cn/img/cnr/CNRCDP/2025/0717/7064a6085a751752723876909641854010.png?auth=902f1d2414fd57e054bfd6d73814c346'][index];

            return `
              <div class="flex__row ranking__list__item">
                  <div class="ranking__list__item__content__num">
                    <div class="svgIcon"><img src="${svgIcon}"></div>
                    <div class="ranking__list__item__content__num_text">${index + 1}</div>
                  </div>
                  <div class="ranking__list__item__content">
                    <div class="news--body--item--text">
                      <div class="news--body--item--text--title">
                        <a href="//www.cnr.cn/ygduanju/video.html?id=${item.shortPlayId}" target="_blank">${item.shortPlayTitle}</a>
                      </div>
                    </div>
                    <div class="ranking__list__item__content__trend">
                      <span class="${trendIcon}"></span>
                    </div>
                    <div class="ranking__list__item__content__other">
                      <span class="ranking__list__item__content__other__play">
                        <span class="tag">播放量</span>
                        <span class="number">${(item.viewCount + '').slice(0, -4) + 'W'}</span>
                      </span>
                    </div>
                  </div>
                  <div class="news--body--item--pic">
                    <div class="playlet--poster">
                      <div class="playlet--poster__vertical">
                        <a target="_blank" href="//www.cnr.cn/ygduanju/video.html?id=${item.shortPlayId}">
                          <img crossorigin="anonymous" class="playlet--poster--image" src="${item.img1}" alt="">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
            `;
          }).join(''),
        );
      } else {
        console.log(data.message);
      }
    },
    fail: function (err) {
      console.log(err);
    },
  });

  // 红榜
  $.ajax({
    url: '//apppc.cnr.cn/shortplays/rank',
    type: 'post',
    dataType: 'json',
    data: JSON.stringify({
      rankType: 3,
      pageIndex: 1,
      perPage: 5,
    }),
    success: function (data) {
      if (data.code === 200) {
        const result = data.data.rankList;
        $('.ranking__observe__top.red ul').html(
          result.map((item, index) => `<li>${item.shortPlayTitle}</li>`).join(''),
        );
      } else {
        console.log(data.message);
      }
    },
    fail: function (err) {
      console.log(err);
    },
  });
  // 黑榜
  $.ajax({
    url: '//apppc.cnr.cn/shortplays/rank',
    type: 'post',
    dataType: 'json',
    data: JSON.stringify({
      rankType: 4,
      pageIndex: 1,
      perPage: 5,
    }),
    success: function (data) {
      if (data.code === 200) {
        const result = data.data.rankList;
        $('.ranking__observe__top.black ul').html(
          result.map((item, index) => `<li>${item.shortPlayTitle}</li>`).join(''),
        );
      } else {
        console.log(data.message);
      }
    },
    fail: function (err) {
      console.log(err);
    },
  });


  // 简介、出品数据
  $.ajax({
    url: 'https://apppc.cnr.cn/shortplays/home',
    type: 'post',
    dataType: 'json',
    data: JSON.stringify({}),
    success: function (data) {
      if (data.code == 200) {
        const { shortPlayList } = data.data;
        $('#jqjc .info .info__content__text').text(shortPlayList[0].textLongDesc || '简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介');
        //$('#jqjc .chupin .detail-info-des').text(shortPlayList[0].producer || '出品方');
        // $('#jqjc .danwei .detail-info-des').text(shortPlayList[0].producer);
        $('#szqn .info .info__content__text').text(shortPlayList[1].textLongDesc || '简介简介简介简介简介简介简介简介简介');
        //$('#szqn .chupin .detail-info-des').text(shortPlayList[1].producer || '出品方');
        // $('#szqn .danwei .detail-info-des').text(shortPlayList[1].producer);
        $('#jxgjlddrw .info .info__content__text').text(shortPlayList[2].textLongDesc || '简介简介简介简介简介简介简介简介简介');
        //$('#jxgjlddrw .chupin .detail-info-des').text(shortPlayList[2].producer || '出品方');
        // $('#jxgjlddrw .danwei .detail-info-des').text(shortPlayList[2].producer);
      } else {
        console.log(data.message);
      }
    },
    fail: function (err) {
      console.log(err);
    },
  });

  // 看剧列表加载颜色
  function renderColor() {
    const colorThief = new ColorThief();
    const imgs = $('.viewshort--list .playlet--poster--image');
    imgs.each(function (index, img) {
      if (img.complete) {
        const rgb = colorThief.getColor(img);
        const color = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)`;
        const $span = $(img).next('.color');
        $span.attr({ style: `background: linear-gradient(to top, ${color} 0%, ${color} 20%, rgba(0, 0, 0, 0) 50%);` });
      } else {
        $(img).on('load', function () {
          const rgb = colorThief.getColor(img);
          const color = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)`;
          const $span = $(img).next('.color');
          $span.attr({ style: `background: linear-gradient(to top, ${color} 0%, ${color} 20%, rgba(0, 0, 0, 0) 50%);` });
        });
      }
    });
  }

  const $duanjuList = $('.viewshort--list');
  function getShortPlaysList(pageIndex) {
    $.ajax({
      url: '//apppc.cnr.cn/shortplays/list',
      type: 'post',
      dataType: 'json',
      data: JSON.stringify({
        pageIndex: pageIndex,
        perPage: 32,
      }),
      success: function (data) {
        if (data.code == 200) {
          const result = data.data.shortPlayList;
          let str = '';
          for (let i = 0; i < result.length; i++) {
            str += `
                <div class="playlet--wrap">
                  <div class="playlet--poster">
                    <a target="_blank" href="//www.cnr.cn/ygduanju/video.html?id=${result[i].id}">
                      <div class="playlet--poster__horizontal">
                        <img crossorigin="anonymous" class="playlet--poster--image" src="${result[i].picType1[0].picUrl}" alt="" />
                        <span class="color"></span>
                      </div>
                    </a>
                  </div>
                  <div class="playlet--info">
                    <div class="playlet--name">
                      <a target="_blank" href="//www.cnr.cn/ygduanju/video.html?id=${result[i].id}">${result[i].shortPlayTitle}</a>
                    </div>
                    <div class="playlet--tag">
                      <a target="_blank" href="//www.cnr.cn/ygduanju/video.html?id=${result[i].id}">${result[i].textLongDesc}</a>
                    </div>
                  </div>
                </div>`;
          }
          $duanjuList.html(str);

          renderColor();
        } else {
          console.log(data.message);
        }
      },
      fail: function (err) {
        console.log(err);
      },
    });
  }
  getShortPlaysList(1);
});
